// 出水水质分析
import React from "react";
import * as echarts from "echarts/lib/echarts";
import moment from "moment";

let myChart = null;
class Ocharts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return <div id="ocharts"></div>;
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    myChart = !myChart
      ? echarts.init(document.getElementById("ocharts"))
      : myChart;
    let day = [];
    let cod = [];
    let tn = [];
    let nh3n = [];
    let tp = [];
    let ss = [];
    Object.keys(nextProps.data.data).map((item) => {
      nextProps.data.data[item].map((iitem) => {
        day.push(moment(iitem.createTime).format("MM-DD HH:mm"));
        const value = iitem.value;
        if (iitem.type == 1) {
          cod.push(value);
        } else if (iitem.type == 2) {
          tn.push(value);
        } else if (iitem.type == 3) {
          nh3n.push(value);
        } else if (iitem.type == 4) {
          tp.push(value);
        } else if (iitem.type == 7) {
          ss.push(value);
        }
      });
    });
    let newday = day.filter((x, index, self) => self.indexOf(x) === index);
    let option = {
      backgroundColor: "#fff",
      color: ["#73A0FA", "#73DEB3", "#9013FE", "#FFB761"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
          lineStyle: {
            type: "dashed",
          },
        },
      },
      grid: {
        left: "25",
        right: "25",
        bottom: "44",
        top: "85",
        containLabel: true,
      },
      legend: {
        data: ["COD", "TN", "NH3_N", "TP"],
        orient: "horizontal",
        icon: "rect",
        show: true,
        left: 20,
        top: 5,
      },
      xAxis: {
        type: "category",
        data: newday,
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
      },
      dataZoom: [
        {
          type: "inside",
          start: 0,
          end: 100,
        },
        {
          start: 0,
          end: 100,
        },
      ],
      yAxis: {
        type: "value",
        // max: max_value>=100? max_value + 100: max_value+10,
        // max: max_value > 100 ? max_value * 2 : max_value + 10,
        // interval: 10,
        // nameLocation: "center",
        axisLabel: {
          color: "#999",
          fontSize: 12,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#F3F4F4",
          },
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        name: "mg/L",
      },
      series: [
        {
          name: "COD",
          type: "line",
          smooth: true,
          data: cod,
        },
        {
          name: "TN",
          type: "line",
          smooth: true,
          data: tn,
        },
        {
          name: "NH3_N",
          type: "line",
          smooth: true,
          data: nh3n,
        },
        {
          name: "TP",
          type: "line",
          smooth: true,
          data: tp,
        },
      ],
    };

    myChart.setOption(option);
    window.addEventListener("resize", this.resizeFn);
  }

  resizeFn() {
    myChart.resize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFn);
    myChart = null;
  }
}

export default Ocharts;
